import { UPDATE_FROM_API } from "../riskPilotConstant";

export const updateFromApi = (apiData, riskOwners) => ({
  type: UPDATE_FROM_API,
  payload: { apiData, riskOwners },
});
